<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>VIEW - SPECIES MANAGEMENT</h2>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
       <div class="col-lg-6 col-md-6 col-sm-6 common_title">
<p>Species details</p>
       </div>
       <div class="col-lg-6 col-md-6 col-sm-6 text-right common_title">
         <button  class="btn btn-primary mt-0 mb-0 back_to add"  (click)= "View_Age_Group()">View Age group</button>
       </div>
      </div>
       <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12">
       <div class="grid_view">
       <h3>&nbsp;</h3>
       <div class="card mt-0">
       <div class="card-body">
       <div class="row">
        <div class="col-lg-4 col-sm-4 col-12">
      <p><span class="blue">Farm Name:&nbsp;</span><span id="farmName" ></span></p>
        </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Species Name:&nbsp;</span><span id="speciesviewName" ></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Species ID:&nbsp;</span><span id="speciesviewId"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Status:&nbsp;</span><span id="speciesviewStatus"></span></p>
        </div>
       </div>
       </div>
       </div>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit" (click)='speciesmanagement()' class="btn btn-fill btn-primary mb-3">
        Back <div class="ripple-container"></div>
       </button>
       <br>
       <!--<button type="submit" class="btn btn-fill btn-default">
        Cancel <div class="ripple-container"></div>
       </button>-->
       </div>
       </div>
     </div>
   </div>
 </div>